export default {
    pageName: 'อุณหภูมิสูง',
    search: {
        title: '',
        placeholder: 'ค้นหาสถานที่'
    },
    header: {
        full: 'สถานที่'
    }
}
